/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type UIAnalyticsEvent from '@atlaskit/analytics-next/UIAnalyticsEvent';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';

export const ViewHeader = {
	copyViewLinkButtonClicked: (event: UIAnalyticsEvent): void => {
		// https://data-portal.internal.atlassian.com/analytics/registry/47649
		fireUIAnalytics(event, 'button clicked', 'copyViewLinkButton');
	},
};
